<template>
  <ConfirmDialog></ConfirmDialog>
  <div class="px-1 md:px-3 py-4 surface-ground ">
    <!-- The `multiple` attribute lets users select multiple files. -->
    <div class="grid w-full h-full ">

      <div class="col bg-white  p-3 text-left line-height-3">
        <!-- <h3 class="mb-0 mt-0 font-light">Abrir</h3> -->

        <div class="w-full">
          <Parametros />
        </div>

        <div class="backup-section">
          <div class="backup-heading">Backup</div>
          <div class="backup-grid">
            <div class="section-card">
              <div class="section-header">
                <i class="pi pi-cloud-download section-icon" />
                <div>
                  <div class="section-title">Copia de seguridad</div>
                  <div class="section-desc">Descargá un respaldo de tus datos o restauralos desde un archivo</div>
                </div>
              </div>
              <div class="backup-actions">
                <Button label="Descargar datos" icon="pi pi-download" outlined size="small" data-e2e="btn-descargar-datos" @click="downloadFile" />
                <FileUpload
                  ref="fileInput"
                  chooseLabel="Restaurar datos"
                  chooseIcon="pi pi-folder-open"
                  uploadIcon="pi pi-upload"
                  mode="basic"
                  name="file"
                  accept=".territorio,application/json"
                  class="backup-file-upload"
                  @select="fileChange"
                />
              </div>
            </div>

            <div class="section-card">
              <div class="section-header">
                <i class="pi pi-whatsapp section-icon" />
                <div>
                  <div class="section-title">¿Necesitás ayuda?</div>
                  <div class="section-desc">Consultas y sugerencias sobre el sistema</div>
                </div>
              </div>
              <a
                href="https://api.whatsapp.com/send?phone=5492644766180&text=Hola,%20tengo%20una%20consulta%20sobre%20el%20sistema%20de%20territorios."
                class="p-button p-button-success no-underline w-fit"
                target="_blank"
                rel="noopener noreferrer"
              ><i class="pi pi-whatsapp mr-2" />Escribinos</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref } from 'vue'
import { useTerritoriosStore } from '@/store/territorios'
import { useSalidaStore } from "@/store/useSalidaStore";
import { useTrabajoStore } from "@/store/useTrabajoStore";
import { useMapStore } from '@/store/map'
import { DEFAULT_CENTER } from '@/store/mapConstants'
import { useRouterStore } from '@/store/router'
import { useRutasStore } from '@/page/rutas/useRutasStore'
import ConfirmDialog from 'primevue/confirmdialog';
import Parametros from '@/components/Parametros.vue'
import { useAppToast } from '@/composables/useAppToast'

const toast = useAppToast()
const territorios = useTerritoriosStore()
const trabajo = useTrabajoStore()
const salida = useSalidaStore();
const route = useRouterStore()
const rutasStore = useRutasStore()

const m = useMapStore()

const fileInput = ref("null");

const fileChange = (e) => {
  console.log("fileChange", e);
  try {
    let file = e.files[0];
    const reader = new FileReader();
    reader.readAsText(file, "UTF-8");
    reader.onload = function (result) {
      // console.log( );
      let data = JSON.parse(result.target.result);
      for (let i = 0; i < data.territorios.length; i++) {
        if (!data.territorios[i].color) {
          data.territorios[i].color = {
            backgroundColor: "rgb(255, 255, 254)",
            color: "#000000",
          };
        }
      }
      const toObj = (arr) =>
        (arr || []).map((item) =>
          typeof item === 'string' ? { id: crypto.randomUUID(), name: item } : item
        )
      territorios.$patch({
        list: data.territorios || [],
        puntoEncuentro: (data.puntoEncuentro || []).map((p) =>
          p.id ? p : { ...p, id: crypto.randomUUID() }
        ),
        congregacion: data.congregacion || "",
        grupos: toObj(data.grupos),
        asignados: data.territoriosAsignados || [],
      });
      m.setCenter({ center: data.center || DEFAULT_CENTER });
      if (data.trabajo) {
        trabajo.$patch({ data: data.trabajo });
      }

      rutasStore.$patch({ list: data?.rutas || [] });
      if (data.salida) {
        salida.$patch({
          horarios: data.salida.horarios,
          conductores: toObj(data.salida.conductores),
          list: data.salida.list,
          history: data.salida.history,
        });
      }
      route.$patch({ page: "listaTerritorio" });
    };
    reader.onerror = function (err) {
      console.error(err.target.result);
    };
  } catch (e) {
    console.error(e);
    toast.error("Ocurrió un error", "Recarga y vuelve a intentar.");
  }
};

const downloadFile = () => new Promise((resolve, reject) => {
  //create or obtain the file's content
  let data = {
    version: 1,
    congregacion: territorios.congregacion,
    center: m.center,
    territorios: territorios.list,
    territoriosAsignados: territorios.asignados,
    puntoEncuentro: territorios.puntoEncuentro,
    grupos: territorios.grupos,
    trabajo: trabajo.data,
    rutas: rutasStore.list,
    salida: {
      horarios: salida.horarios,
      conductores: salida.conductores,
      list: salida.list,
      history: salida.history
    }
  }
  // console.log("data", data)
  var content = JSON.stringify(data);
  const blob = new Blob([content], { type: 'application/json' });
  //create a file and put the content, name and type
  var file = new File([blob], 'miterritorio.json');

  //create a ObjectURL in order to download the created file
  let url = window.URL.createObjectURL(file);

  //create a hidden link and set the href and click it
  var a = document.createElement("a");
  a.style = "display: none";
  a.href = url;
  a.download = file.name;
  a.click();
  window.URL.revokeObjectURL(url);
  setTimeout(() => {
    return resolve();
  }, 1000);
})

</script>

<style scoped>
.backup-section {
  margin-top: var(--space-6);
}

.backup-heading {
  font-weight: var(--weight-semibold);
  font-size: var(--text-title-3);
  color: var(--label-primary);
  margin-bottom: var(--space-3);
}

.backup-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1rem;
  align-items: stretch;
}

.backup-section .section-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: var(--bg-primary);
  border-radius: var(--radius-lg);
  padding: 1.25rem 1.25rem 1rem;
  box-shadow: var(--shadow-1);
  text-align: left;
}

.backup-section .section-header {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.backup-section .section-icon {
  font-size: 1.1rem;
  color: var(--accent);
  margin-top: 2px;
  flex-shrink: 0;
}

.backup-section .section-title {
  font-weight: var(--weight-semibold);
  font-size: var(--text-title-3);
  color: var(--label-primary);
  line-height: 1.3;
}

.backup-section .section-desc {
  font-size: var(--text-footnote);
  color: var(--label-secondary);
  margin-top: 2px;
  line-height: 1.4;
}

.backup-actions {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

:deep(.backup-file-upload) {
  background: transparent;
  color: var(--accent);
  border: 1px solid var(--accent);
}

:deep(.backup-file-upload:hover) {
  background: var(--accent-soft);
}

.w-fit {
  width: fit-content;
}
</style>

<style>
.open
{
  position: relative;
  width: 60%;
  height: 50px;
  overflow: none;
}

.open p
{
  height: 100%;
  text-align: center;
}

.open input
{
  height: 100%;
  position: absolute;
  opacity: 0;
}

p {
  max-width: 600px;
}
</style>
